// global.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'globalVariable';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    private globalVariable: BehaviorSubject<any>;

    public globalVariable$: Observable<any>;

    constructor() {
        // 从 localStorage 读取初始值，没有就用 false
        const storedValue = localStorage.getItem(STORAGE_KEY);
        const initialValue = storedValue ? JSON.parse(storedValue) : false;

        this.globalVariable = new BehaviorSubject<any>(initialValue);
        this.globalVariable$ = this.globalVariable.asObservable();
    }

    setGlobalVariable(value: any): void {
        this.globalVariable.next(value);
        console.log('setGlobalVariable')
        localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); // 持久化
    }

    getGlobalVariable(): any {
        return this.globalVariable.getValue();
    }
}